import { typeColor, rootDarkColor } from "../../Components/styles/palette";

const { standard, darkMode } = typeColor

const standardPalette = {
    background: {
        default: "#f5f5f5"
    },
    text: {
        default: standard.default
    },
    textColor: standard.default,
    primary: {
        main: standard.action,
    },
    secondary: {
        main: standard.secondary,
    },
    textPrimary: {
        main: standard.action
    },
    error: {
        main: standard.error
    }
}

const darkModePalette = {
    background: {
        default: rootDarkColor
    },    
    textColor: darkMode.default,
    primary: {
        main: darkMode.action,
    },
    secondary: {
        main: darkMode.secondary,
    },
    error: {
        main: darkMode.error
    }
}

export { standardPalette, darkModePalette }